import { createSlice } from "@reduxjs/toolkit";

//STATE
const state = {
  rows: [],
  itemTypesEdit: {},
  isLoading: false,
  showDialog: false,
};

//STORE SLICE
export const itemTypesEditSlice = createSlice({
  name: "itemTypesEditSlice",
  initialState: state,
  //REDUCER
  reducers: {
    showEditItemTypesDialog(state, action) {
      return {
        ...state,
        showDialog: true,
        itemTypesEdit: action.payload,
      };
    },
    closeEditItemTypesDialog(state) {
      return {
        ...state,
        showDialog: false,
      };
    },
    showLoading(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    hideLoading(state) {
      return {
        ...state,
        isLoading: false,
      };
    },    
  },
});

//ACTIONS
export const {
  showEditItemTypesDialog,
  closeEditItemTypesDialog,
  showLoading,
  hideLoading
} = itemTypesEditSlice.actions;

export default itemTypesEditSlice.reducer;
